import { buildSgPresetPrepareDocumentItem } from '../../presetDocCustSave';
import type { ShareCertificateFormModel } from './useFormPayload';
import { toShareCertificateTemplateVariables } from './useFormPayload';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
  docCode?: string;
}

export function isShareCertificateDoc(doc: SelectionDocRow): boolean {
  const code = String(doc.docCode || '').trim().toUpperCase();
  const name = String(doc.templateName || '').toLowerCase();
  if (code === 'PRS014') return true;
  return /share\s*certificate/.test(name);
}

export function buildShareCertificatePresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  model: ShareCertificateFormModel;
  personName: string;
  entityCd?: string;
}) {
  const docs = (input.selectionDocuments || []).filter((d) => d.tmpId && isShareCertificateDoc(d));
  if (docs.length === 0) return [];

  const commonFormData = toShareCertificateTemplateVariables(input.model);
  return docs.map((d) =>
    buildSgPresetPrepareDocumentItem({
      templateId: d.tmpId as number | string,
      templateName: d.templateName || 'Share Certificate',
      personName: input.personName || input.model.memberName || '',
      commonFormData,
      entityCd: input.entityCd,
    }),
  );
}
